<template>
    <div class="grid grid-cols-1 gap-6">
        <div class="flex flex-col bg-white rounded-lg shadow">
            <div class="p-4">
                <div class="font-semibold">
                    {{ $t('Tickets by types') }}
                </div>
            </div>
            <div class="p-4">
                <loading :status="loading"/>
                <pie-chart ref="chart" :chart-data="chartData" :height="350"></pie-chart>
            </div>
        </div>
    </div>
</template>

<script>
import PieChart from "@/components/charts/pie-chart";

export default {
    name: "opened-tickets",
    components: {PieChart},
    data() {
        return {
            loading: true,
            chartData: {
                labels: [
                    this.$t('Jan'), this.$t('Feb'), this.$t('Mar'), this.$t('Apr'), this.$t('May'), this.$t('Jun'), this.$t('Jul'), this.$t('Aug'), this.$t('Sept'), this.$t('Oct'), this.$t('Nov'), this.$t('Dec')
                ],
                datasets: [
                    {
                        label: this.$i18n.t('Tickets'),
                        backgroundColor: ['#1e3a8a', '#1e40af', '#1d4ed8', '#2563eb', '#3b82f6', '#4299e1', '#4361ee', '#4f46e5', '#5a67d8', '#6366f1'],
                        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    }
                ],
            }
        }
    },
    computed: {
        datasets() {
            return this.chartData.datasets[0].data
        }
    },
    watch: {
        datasets() {
            this.$refs.chart.update();
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData(filter) {
            const self = this;
            self.loading = true;
            axios.get('api/dashboard/stats/tickets-types', { params: filter }).then(function (response) {
                self.chartData.datasets[0].data = response.data.values;
                self.chartData.labels = response.data.labels;
                self.loading = false;
            });
        }
    },
}
</script>
